import script from "./SelectMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SelectMenu.vue?vue&type=style&index=0&id=7e007b83&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SelectMenu.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e007b83"]])

export default __exports__